import _regeneratorRuntime from "@babel/runtime/regenerator";
import { __awaiter } from "tslib";
import cx from 'classnames';
import React from 'react';
import { withNativeProps } from '../../utils/native-props';
var classPrefix = 'nib-dialog-button';
export var DialogActionButton = function DialogActionButton(props) {
  var action = props.action;

  function handleClick() {
    var _a, _b;

    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action);

            case 3:
              _context.next = 5;
              return (_b = props.onAction) === null || _b === void 0 ? void 0 : _b.call(props);

            case 5:
              _context.next = 9;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));
  }

  return withNativeProps(props.action, /*#__PURE__*/React.createElement("div", {
    className: cx(classPrefix, classPrefix + "-" + (action.color || 'default')),
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("span", {
    className: classPrefix + "-text"
  }, action.text)));
};